import { FormGroup, Input } from 'reactstrap';

export function InstancesListBody(props) {
    const { instances, selectedInstanceIds, handleSelectSingleInstanceClick } =
        props;

    return (
        <tbody className="practice-list-body">
            {instances.map((instance) => (
                <tr className="practice-list-record" key={instance.id}>
                    <td className="practice-list-select-col">
                        <FormGroup check inline>
                            <Input
                                type="checkbox"
                                checked={selectedInstanceIds.includes(
                                    instance.id
                                )}
                                onClick={() =>
                                    handleSelectSingleInstanceClick(instance.id)
                                }
                            />
                        </FormGroup>
                    </td>
                    <td className="practice-list-instance-id-col">
                        {instance.id}
                    </td>
                    <td className="practice-list-prac-name-col">
                        {instance.practice?.name}
                    </td>
                    <td className="practice-list-pims-col">
                        {instance.practice?.pimsInfo?.displayName}
                    </td>
                    <td className="practice-list-pims-version-col">
                        {instance.practice?.pimsVersionInfo?.version}
                    </td>
                </tr>
            ))}
        </tbody>
    );
}
